export function getLocalizedLanguageName(code: string): string {
  try {
    const displayNames = new Intl.DisplayNames([navigator.language], {
      type: "language",
    });
    return displayNames.of(code) ?? "English";
  } catch {
    return "English";
  }
}
